<div class="logo-container" [ngClass]="{'small': small, 'rotated': rotate$ | async, 'full': full }">
  @if (profileReady$ | async) {
    <img src="{{ url$ | async }}" class="logo m-auto" alt="{{ profileIdentityName$ | async }}">
  }
</div>
